import AdminConfigTabs from '../screens/AdminConfigTabs'
import { ROLE, RouteWithAccessType } from './types'

const adminConfigRoleManagement: RouteWithAccessType[] = [
  {
    route:
      '/admin-config/(log|security|authentication-history|tenant-export|user-sessions)',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['admin.config.view'],
    // Each tab carries the route's own feature, deliberately — the page has ONE
    // feature covering all of it, and inventing per-tab features here would be a
    // permissions decision rather than a fix. Declaring them is what canAccessTab
    // needs: with no tabs it finds no tabConfig and refuses everyone, which left this
    // screen redirecting every visitor to /403 (BL-059).
    tabs: [
      {
        params: { page: 'log' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['admin.config.view']
      },
      {
        params: { page: 'security' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['admin.config.view']
      },
      {
        params: { page: 'authentication-history' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['admin.config.view']
      },
      {
        params: { page: 'tenant-export' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['admin.config.view']
      },
      {
        params: { page: 'user-sessions' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['admin.config.view']
      }
    ],
    component: <AdminConfigTabs />
  }
]

export default adminConfigRoleManagement
